export function formatPrice(price: number, currency: string, locale: string = "pl-PL") {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(price);
}
// TODO: LOCALE!!!